import { sanitizeForRendering } from "../../helpers/html";

type Props = {
  html: string;
};

const HtmlSnippet = ({ html }: Props) => {
  const sanitized = sanitizeForRendering(html);
  return <>{sanitized}</>;
};

export default HtmlSnippet;
